var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsoBumeran(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.623 47.884C47.712 45.541 50 42.147 50 35.175c0-6.97-3.079-10.109-3.079-10.109l-1.023-1.208L20.678-5.56a9.846 9.846 0 00-3.038-2.399 9.567 9.567 0 00-7.5-.506 9.75 9.75 0 00-3.317 1.97l-.097.09A10.042 10.042 0 004.4-3.28a10.322 10.322 0 00-.476 7.7 10.135 10.135 0 001.925 3.4l18.715 21.866a8.152 8.152 0 012.063 5.382 7.574 7.574 0 01-.612 3.03 7.397 7.397 0 01-1.765 2.509L2.445 61.164A10.266 10.266 0 00.02 68.467a10.197 10.197 0 003.305 6.93l.105.09a9.655 9.655 0 007.105 2.493c2.596-.17 5.021-1.39 6.742-3.395l28.346-26.7z",
    fill: "#3DE5DF"
  })));
}
export default __webpack_public_path__ + "static/media/iso-bumeran.acf9a018.svg";
export { SvgIsoBumeran as ReactComponent };